import * as yup from 'yup';

export const emailValidationForm = (message: string) => {
  const EMAIL_REGEXP = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, 'gm');

  return yup.string().matches(EMAIL_REGEXP, message);
};
